import axios from 'axios';

// export const API_BASE_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_BASE_URL_DEV : process.env.REACT_APP_API_BASE_URL_PROD;
export const API_BASE_URL = "https://photoskiff.com/zaruba/dbapi";

// Get all contests
export const getContests = async () => {
  const response = await axios.get(`${API_BASE_URL}/contests`);
  return response.data;
};

export const getContest = async (contestId: string) => {
  const response = await axios.get(`${API_BASE_URL}/contests/${contestId}`);
  return response.data;
};

// Get presentation data for a specific contest
export const getContestPresentationData = async (contestId: number) => {
  const response = await axios.get(`${API_BASE_URL}/contests/${contestId}/presentation`);
  return response.data;
};

// Get ranking data for a specific contest
export const getContestRankingData = async (contestId: number) => {
  const response = await axios.get(`${API_BASE_URL}/contests/${contestId}/ranking`);
  return response.data;
};

export const checkParticipantExists = async (id: number) => {
  const response = await axios.get(`${API_BASE_URL}/admin/participant-exists/${id}`);
  return response.data.exists;
}


export const getParticipantById2 = async (id: number)  => {
  const response = await axios.get(`${API_BASE_URL}/participants2/${id}`);
  const data = response.data;
  const info = data.info ? JSON.parse(data.info) : {};
  return {...data, info:info.info, links:info.links};
}

export const getParticipantById = async (id: string)  => {
  const response = await axios.get(`${API_BASE_URL}/participants/${id}`);
  const data = response.data;
  const info = data.info ? JSON.parse(data.info) : {};
  return {...data, info:info.info, links:info.links};
}

export interface Participant {
  participant_id: number;
  name: string;
  age: number;
  created_at: string;
  external_id: string | null;
  gender: string;
  age_group_name: string;
  total_entries: number;
  profile_picture: string;
}


export interface AgeGroup {
  age_group_id: number;
  age_group_name: string;
}


// Function to fetch participants
export const fetchParticipants = async (): Promise<Participant[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/participants`);
    return response.data;
  } catch (error) {
    console.error('Error fetching participants:', error);
    throw error; // Throw error to handle it in the component
  }
};

// Upload profile picture
export const uploadProfilePicture = async (profilePicture: File): Promise<string> => {
  const formData = new FormData();
  formData.append('profile_picture', profilePicture);

  const response = await axios.post(`${API_BASE_URL}/upload-profile-picture`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data.tempImageName;
};

// Add or update a participant
// Add or update a participant
export const addOrUpdateParticipant = async (payload: any) => {
  await axios.post(`${API_BASE_URL}/participants`, payload);
};



// Fetch participant by ID
export const fetchParticipantById = async (participantId: number): Promise<Participant> => {
  const response = await axios.get(`${API_BASE_URL}/participants/${participantId}`);
  return response.data;
};

// Define interfaces for ranking data and contest metadata
export interface RankingEntry {
  participant_name: string;
  participant_id: number;
  ranking: number;
  result: number;
  result_unit: string;
  grouping: string;
  evidence_url: string;
  profile_picture: string;
  [key: string]: any; // Allow dynamic fields based on metadata
}

export interface ContestField {
  field_name: string;
  display_label: string;
  result_field: boolean;
  non_entry_field?: boolean;
  main_result_field?: boolean;
}

export type ContestGrouping = {
  grouping: string,
  group_count: number
}

export const fetchContestGroupings = async (contestId: string): Promise<string[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/contest/${contestId}/groupings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching groupings:', error);
    throw error;
  }
};

// Fetch groupings for a contest
export const fetchContestGroupings2 = async (contestId: string): Promise<ContestGrouping[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/contest/${contestId}/groupings2`);
    return response.data;
  } catch (error) {
    console.error('Error fetching groupings:', error);
    throw error;
  }
};

// Fetch contest rankings for a specific grouping
export const fetchContestRankings = async (contestId: string, grouping: string): Promise<RankingEntry[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/contests/${contestId}/rankings`, {
      params: { grouping },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching rankings:', error);
    throw error;
  }
};

// Fetch contest metadata
export const fetchContestMetadata = async (contestId: string): Promise<ContestField[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/contest/${contestId}/metadata`);
    const resultFields = response.data?.fields?.filter((field: ContestField) => field.result_field) ?? [];
    return resultFields;
  } catch (error) {
    console.error('Error fetching contest metadata:', error);
    throw error;
  }
};

export interface AgeGroup {
  age_group_id: number;
  age_group_name: string;
  min_age: number;
  max_age: number;
}

// Add this function in api/contests.ts
export const fetchAgeGroups = async (): Promise<AgeGroup[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/age-groups`);
    return response.data;
  } catch (error) {
    console.error('Error fetching age groups:', error);
    throw error;
  }
};

export interface Entry {
  participant_id: number;
  name: string,
  username: string;
  first_name: string;
  last_name?: string;
  contest_id: number;
  contest_name: string;
  profile_picture: string;
  participant_data?: string;
  evidence_url?: string;
  timestamp?: string;
  grouping: string;
}

// API call to fetch the latest contest entries
export const fetchLatestEntries = async (limit: number = 10): Promise<Entry[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/latest-entries`, {
      params: { limit }
    });
    return response.data as Entry[];
  } catch (error) {
    console.error('Error fetching latest entries:', error);
    throw error;
  }
};


